import { Box, LinearProgress, styled } from '@mui/joy';

export const Progress = styled(LinearProgress)({
  '--LinearProgress-radius': '0px',
  position: 'absolute',
  width: '100%',
  marginBottom: 24,
});

export const StepWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%',
  flex: 1,
});
